import React from 'react';
export default function Divider(_a) {
    var children = _a.children;
    return React.createElement("span", { className: "react-time-picker__inputGroup__divider" }, children);
}
